<div role="tablist"
     class="switcher-type mb-5 mx-auto"
     id="account_mode_switcher"
     [attr.aria-label]="'aria.account_mode' | translate">

    <div class="switcher-type__item"
         [class.switcher-type__item--selected]="mode === accountModeType.Phone">
        <span class="pseudo pseudo--border-off"
              (keydown.arrowLeft)="clickItem(accountModeType.Phone)"
              (keydown.arrowRight)="clickItem(accountModeType.Email)"
              role="tab"
              [attr.aria-selected]="mode === accountModeType.Phone"
              [class.pseudo--selected]="mode === accountModeType.Phone"
              [tabindex]="mode === accountModeType.Phone ? 0 : -1"
              aria-controls="phone-field"
              id="phone-field-tab"
              (click)="clickItem(accountModeType.Phone)">
            {{ 'app.form.labels.phoneNumber' | translate | uppercase }}</span>

    </div>
    <div class="switcher-type__item"
         [class.switcher-type__item--selected]="mode === accountModeType.Email">

        <span class="pseudo pseudo--border-off"
            (keydown.arrowLeft)="clickItem(accountModeType.Phone)"
            (keydown.arrowRight)="clickItem(accountModeType.Email)"
            role="tab"
            id="email-field-tab"
            aria-controls="email-field"
            [attr.aria-selected]="mode === accountModeType.Email"
            [class.pseudo--selected]="mode === accountModeType.Email"
            [tabindex]="mode === accountModeType.Email ? 0 : -1"
            (click)="clickItem(accountModeType.Email)">
          {{ 'app.form.labels.email' | translate | uppercase }}</span>

    </div>
</div>
